import LoginPage from "../views/LoginPage.vue";
import SSO from "../views/SSO.vue";
import ValidateJWT from "../views/ValidateJWT.vue";
import store from "../store";
import { logDetailed } from "../helpers/utils";
export default [
  {
    path: "/",
    beforeEnter: (to, from, next) => {
      if (store.getters.isAuthenticated) next("/patients");
      else next("/login");
    },
  },
  {
    path: "/unsupportedDevice",
    name: "unsupportedDevice",
    meta: {
      title: "Unsupported Device"
    },
    component: () => import("../views/UnsupportedDevice.vue"),
    beforeEnter(to, from, next) {
      logDetailed("routes", "/unsupportedDevice", "entering unsupported device page");
      if (store.getters.belowMobileCutoff) next();
      else next("/");
    }
  },
  {
    path: "/unsupportedBrowser",
    name: "unsupportedBrowser",
    meta: {
      title: "Unsupported Browser"
    },
    component: () => import("../views/UnsupportedBrowser.vue"),
    beforeEnter(to, from, next) {
      logDetailed("routes", "/unsupportedBrowser", "entering unsupported browser page");
      next();
    }
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login",
      guest: true,
    },
    component: LoginPage,
    beforeEnter(to, from, next) {
      logDetailed("routes", "/login", "entering login page");
      if (store.getters.isAuthenticated) next("/patients");
      else next();
    }
  },
  {
    path: "/sso",
    name: "sso",
    meta: {
      title: "Logging in"
    },
    component: SSO,
    beforeEnter(to, from, next) {
      logDetailed("routes", "/sso", "entering sso page");
      next();
    }
  },
  {
    path: "/validateJWT",
    name: "validateJWT",
    meta: {
      title: "Logging in"
    },
    component: ValidateJWT,
    beforeEnter(to, from, next) {
      logDetailed("routes", "/validateJWT", "entering validateJWT page");
      next();
    }
  },
  {
    path: "/patients",
    name: "patients",
    meta: {
      title: "Patients",
      requiresAuth: true,
    },
    component: () => import("../views/PatientListPage.vue"),
    beforeEnter(to, from, next) {
      logDetailed("routes", "/patients", "entering patients page");
      if (from.path == "/imageBrowserTest") next();
      else store.dispatch("ensureStaticListsLoaded", false).then(next);
    },
  },
  {
    path: "/qrcode",
    name: "qrcode",
    meta: {
      title: "qrcode",
      requiresAuth: false
    },
    component: () => import("../views/QRPage.vue"),
  },
  {
    path: "/imageBrowserTest",
    name: "imageBrowserTest",
    meta: {
      title: "ImageBrowserTest",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (store.getters.exam) next();
      else next("/patients");
    },
    component: () => import("../views/ImageBrowserTest.vue")
  },
  {
    path: "/adminpanel",
    name: "adminpanel",
    meta: {
      title: "AdminPanel",
      requiresAuth: true
    },
    component: () => import("../views/AdminPanelPage.vue"),
    beforeEnter(to, from, next) {
      if (!store.getters.userIsAdmin) next("/patients");
      logDetailed("routes", "/adminpanel", "entering adminpanel page");
      store.dispatch("ensureStaticListsLoaded", true).then(next);
    }
  },
  {
    path: "/printImages",
    name: "printImages",
    meta: {
      title: "PrintImages"
    },
    component: () => import("../views/PrintImages.vue")
  },
  {
    path: "/Default.aspx",
    beforeEnter(to, from, next) {
      next({ name: "sso", query: to.query });
    }
  },
  {
    path: "/emrstat",
    name: "emrstat",
    meta: {
      title: "EMR Stats"
    },
    component: () => import("../views/Emrstat.vue"),
    beforeEnter(to, from, next) {
      logDetailed("routes", "/emrstat", "entering emrstat page");
      next();
    }
  },
  {
    path: "*",
    beforeEnter(to, from, next) {
      next("/");
    }
  }
];
